module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/7c701343b588364c743fb180ac9c9363.png";